var workbook = (function () {
    let workbookConfig: WorkbookConfig;
    function setup(workbookId, reloadManually: boolean = false) {
        internalSetup(workbookId, true, null, 0, false, null, reloadManually);
    }
    function exportPrintSetup(workbookId: number, tabId: number, widgetId: number = 0, isExcelCSV: boolean = false, scheduledEmailId: number = null) {
        internalSetup(workbookId, false, tabId, widgetId, isExcelCSV, scheduledEmailId);
    }
    function internalSetup(workbookId, async: boolean = true, tabId: number = null, widgetId: number = 0, isExcelCSV: boolean = false,
        scheduledEmailId: number = null, reloadManually: boolean = false) {
        if (workbookId < 0 && !window.location?.href?.includes("/edit/")) {
            window.history.replaceState("", "", `${urlConfigs.tabs}edit/${workbookId}`);
        }

        let href = window.location.href;
        if (window.location?.href?.includes("loadFromDb=True") || window.location?.href?.includes("?tabId") || window.location?.href?.includes("reloadManually")) {
            href = window.location.href.replace(/&?loadFromDb=True/, "").replace(/&?reloadManually=True/, "").replace(/tabId=\d+&?/, "").replace(/\?$/, "");
            window.history.replaceState("", "", href);
        }

        let url = `${urlConfigs.siteRoot}wb/get/${workbookId}`;
        if (tabId) {
            url += `?tabId=${tabId}`;

            if (widgetId !== 0) {
                url += `&widgetId=${widgetId}`;
            }

            if (isExcelCSV) {
                url += `&isExcelCSV=${isExcelCSV}`;
            }

            if (scheduledEmailId) {
                url += `&scheduledEmailId=${scheduledEmailId}`;
            }
        }

        let o = {
            verb: "GET",
            url: url,
            data: {
                workbookId: workbookId,
                tabId: tabId,
                isExcelCSV: isExcelCSV,
                scheduledEmailId: scheduledEmailId
            },
            dataType: "json",
            async: async
        } as RequestServerParams;
        o.successFunction = function (data: any) {
            workbookConfig = new WorkbookConfig(data);
            workbookConfig.scheduledEmailId = scheduledEmailId;
            workbookConfig.reloadManually = reloadManually;
            workbook.workbookConfig = workbookConfig;

            let $workbook = $("#newworkbookpage");
            if ($workbook.length) {
                if (isTouchDevice()) {
                    $workbook.addClass("isTouchDevice");
                }

                ko.applyBindings(workbookConfig, $workbook[0]);
            }
        }
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get workbook";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        }
        irGlobal.requestServer(o);

        var ErrorHandlingBindingProvider = function () {
            var original = new ko.bindingProvider();

            //determine if an element has any bindings
            this.nodeHasBindings = original.nodeHasBindings;

            //return the bindings given a node and the bindingContext
            this.getBindings = function (node, bindingContext) {
                var result;
                try {
                    result = original.getBindings(node, bindingContext);
                }
                catch (e) {
                    if (console && console.log) {
                        console.log("Error in binding: " + e.message);
                        console.log("Node causing error:");
                        console.log(node);
                    }
                }

                return result;
            };
        };

        ko.bindingProvider.instance = new ErrorHandlingBindingProvider();
    }

    return {
        setup,
        exportPrintSetup,
        workbookConfig,
    }
})();